import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { StringMain, TextMain } from '@components/Typography/Typography';
import { CashImage } from '@components/ui/CashImage/CashImage';
import { useAppSelector } from '@redux/store';
import cn from 'classnames';

import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import dicePng from '/img/tgem.png';
import diceWebp from '/img/tgem.webp';

interface MyReferralRewardTableProps {
  className?: string;
}

const MyReferralRewardTable: FC<MyReferralRewardTableProps> = ({
  className,
}) => {
  const referralEarnings = useAppSelector(
    (state) => state.user.referralEarnings?.data,
  );

  const totalCash = referralEarnings?.reduce(
    (acc, current) => acc + current.cash,
    0,
  );
  const totalDice = referralEarnings?.reduce(
    (acc, current) => acc + current.dice,
    0,
  );
  const { t } = useTranslation();

  return (
    <div className={cn('w-full', className)}>
      <div className={cn(css.columnTemplate, 'mb-1')}>
        <StringMain weight="bold">{t('Total')}</StringMain>
        <div className="flex items-center justify-end">
          <CashImage size={24} className="mr-1" />
          <StringMain weight="bold">
            {toShortNumFormat(totalCash || 0)}
          </StringMain>
        </div>
        <div className="flex items-center justify-end">
          <Picture
            img={dicePng}
            webp={diceWebp}
            className="w-6 h-6 shrink-0 mr-1"
            alt="tgem"
          />
          <StringMain weight="bold">
            {toShortNumFormat(totalDice || 0)}
          </StringMain>
        </div>
      </div>
      <div className="w-full flex flex-col gap-2">
        {referralEarnings?.map((item) => (
          <div className={css.columnTemplate} key={item.rewardLevel}>
            <TextMain weight="regular" className="text-white/60">
              {`${t('Tier')} ${item.rewardLevel}`}
            </TextMain>
            <TextMain weight="regular" className="text-white/60 text-right">
              {toShortNumFormat(item.cash)}
            </TextMain>
            <TextMain weight="regular" className="text-white/60 text-right">
              {toShortNumFormat(item?.dice || 0)}
            </TextMain>
          </div>
        ))}
      </div>
    </div>
  );
};

export { MyReferralRewardTable };
